import BaseService from "@/boot/BaseService";
class UserService extends BaseService {
    constructor() {
        super(null, "/users");
    }
    async search(search) {
        return await this.get("/search", { search });
    }
    async index(params) {
        return await this.get("/", params);
    }

    async store(params) {
        return await this.post("", params);
    }

    async update(params) {
        return await this.put(`/${params.id}`, params);
    }

    async setStatus(id) {
        return await this.post(`/set-status/${id}`);
    }

    async assignRole(id, role) {
        return await this.post(`/assign-role/${id}`, { role });
    }

    async removeRole(id, role) {
        return await this.post(`/remove-role/${id}`, { role });
    }

}

export default new UserService();
